import { ImageWidths, ImageWidth } from 'common/helpers/image'
import { distinct } from 'common/helpers/utils'
import { Product } from 'component-library/__product'

type CommonViewPorts1x = 320 | 375 | 414 | 768 | 1024
type CommonViewPorts2x = 640 | 828

type CommonViewPorts = CommonViewPorts1x | CommonViewPorts2x

/**
 * This is a super set of ImageWidths
 *
 * Numbers on the end are just 2x versions of some of the smaller ImageWidths['masthead'] e.g 110 x 2, 88 x 2, 106 x 2
 */
export interface ImageManagerWidths {
    thewest: CommonViewPorts | ImageWidths['thewest'] | 220
    perthnow: CommonViewPorts | ImageWidths['perthnow'] | 176 | 212
    sevennews: CommonViewPorts | ImageWidths['sevennews'] | 220
}

export type AkamaiImageManagerWidth =
    | ImageManagerWidths['thewest']
    | ImageManagerWidths['perthnow']
    | ImageManagerWidths['sevennews']

const commonViewPortWidths: CommonViewPorts[] = [320, 375, 414, 768, 640, 828, 1024]

const thewestImageWidths: ImageWidths['thewest'][] = [110, 150, 268, 500, 810, 860, 1224]
const perthnowImageWidths: ImageWidths['perthnow'][] = [88, 106, 150, 320, 668, 736, 984]
const sevennewsImageWidths: ImageWidths['sevennews'][] = [126, 320, 650]

export const akamaiImageManagerWidths: {
    thewest: ImageManagerWidths['thewest'][]
    perthnow: ImageManagerWidths['perthnow'][]
    sevennews: ImageManagerWidths['sevennews'][]
} = {
    thewest: distinct<ImageManagerWidths['thewest']>([
        ...commonViewPortWidths,
        ...thewestImageWidths,
        220,
    ]),
    perthnow: distinct<ImageManagerWidths['perthnow']>([
        ...commonViewPortWidths,
        ...perthnowImageWidths,
        176,
        212,
    ]),
    sevennews: distinct<ImageManagerWidths['sevennews']>([
        ...commonViewPortWidths,
        ...sevennewsImageWidths,
        220,
    ]),
}

export const getImageManagerWidths = (product: Product): AkamaiImageManagerWidth[] => {
    switch (product) {
        case Product.PerthNow:
            return akamaiImageManagerWidths.perthnow

        case Product.SevenNews:
            return akamaiImageManagerWidths.sevennews

        case Product.TheWest:
            return akamaiImageManagerWidths.thewest
    }
}

// This will return the next highest image width for retina displays
export const get2xNearestImageWidth = (product: Product, imageWidth: ImageWidth) => {
    const widths = getImageManagerWidths(product)
    // get all image widths that are >= the initial * 2
    const higherImageWidths = widths.filter(x => x >= imageWidth * 2)

    if (higherImageWidths.length > 0) {
        return higherImageWidths.sort((a, b) => a - b)[0]
    }

    return null
}
